import React from 'react';
import { Paper, SxProps, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import { dateUtil } from 'coreutil';
import { insertSoftHyphens } from 'coreutil';
import { IAppointmentCombinedState } from 'models';
import { useScreenType } from 'hooks';

interface Props {
	items: IAppointmentCombinedState[];
	sx?: SxProps;
}

export const FollowUpHistory: React.FC<Props> = ({ items, sx }) => {
	const screenType = useScreenType();

	return (
		<Paper elevation={0} sx={{ width: '100%', overflow: 'hidden', ...sx }}>
			<Typography variant='subtitle1' sx={{ pl: 1 }}>
				Follow Up History
			</Typography>
			<TableContainer sx={{ maxHeight: 240, overflow: 'auto' }}>
				<Table stickyHeader>
					<TableHead>
						<TableRow>
							<TableCell
								sx={{
									position: 'sticky',
									top: 0,
									zIndex: 2,
									backgroundColor: theme => theme.palette.background.paper
								}}>
								Appointment
							</TableCell>
							<TableCell
								sx={{
									position: 'sticky',
									top: 0,
									zIndex: 2,
									backgroundColor: theme => theme.palette.background.paper
								}}>
								Date
							</TableCell>
							<TableCell
								sx={{
									position: 'sticky',
									top: 0,
									zIndex: 2,
									backgroundColor: theme => theme.palette.background.paper
								}}>
								Type
							</TableCell>
							<TableCell
								sx={{
									position: 'sticky',
									top: 0,
									zIndex: 2,
									backgroundColor: theme => theme.palette.background.paper
								}}>
								Status
							</TableCell>
							{screenType.isDesktop && (
								<TableCell
									sx={{
										position: 'sticky',
										top: 0,
										zIndex: 2,
										backgroundColor: theme => theme.palette.background.paper,
										width: '160px',
										maxWidth: '160px'
									}}>
									Comments
								</TableCell>
							)}
						</TableRow>
					</TableHead>
					<TableBody>
						{items.map(item => (
							<TableRow key={item.id} hover sx={{ verticalAlign: 'top' }}>
								<TableCell>{item.id}</TableCell>
								<TableCell>
									{dateUtil.formatDate(dateUtil.parseDate(item.leadDate))} {dateUtil.to12HourTime(item.startTime)}
								</TableCell>
								<TableCell>{item.subType}</TableCell>
								<TableCell>{item.status}</TableCell>
								{screenType.isDesktop && (
									<TableCell sx={{ width: '160px', maxWidth: '160px', verticalAlign: 'top' }}>
										<Typography variant='body2' sx={{ whiteSpace: 'normal', display: 'block', width: '100%', overflowWrap: 'anywhere' }}>
											{insertSoftHyphens(item.comments, 1)}
										</Typography>
									</TableCell>
								)}
							</TableRow>
						))}
					</TableBody>
				</Table>
			</TableContainer>
		</Paper>
	);
};
